import React from "react";
import { useAgency } from "../../actions/homeActions";
export default () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const { data: AgencyData, isLoading, isError, error } = useAgency("agency");
  const settings = {
    dots: false,
    infinite: AgencyData?.records?.length > 6,
    slidesToShow:
      AgencyData?.records?.length > 6 ? 6 : AgencyData?.records?.length,
    slidesToScroll: 1,
    autoplay: AgencyData?.records?.length > 6,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    centerMode: false,
    variableWidth: false,
    rtl: true,
    className: AgencyData?.records?.length >= 6 ? "" : "sm:px-5 xl:px-10",
    responsive: [
      {
        breakpoint: 768, // MD screens
        settings: {
          slidesToShow:
            AgencyData?.records?.length >= 3 ? 3 : AgencyData?.records?.length,
          pauseOnHover: true,
          cssEase: "linear",
          infinite: AgencyData?.records?.length > 3,
          autoplay: AgencyData?.records?.length > 3,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: AgencyData?.records?.length >= 3 ? "" : "sm:px-5 xl:px-10",
        },
      },
      {
        breakpoint: 480, // XS screens
        settings: {
          slidesToShow:
            AgencyData?.records?.length >= 3 ? 3 : AgencyData?.records?.length,
          cssEase: "linear",
          infinite: AgencyData?.records?.length > 3,
          autoplay: AgencyData?.records?.length > 3,
          centerMode: false,
          variableWidth: false,
          slidesToScroll: 1,
          className: AgencyData?.records?.length === 1 ? "xs:px-3" : "",
        },
      },
    ],
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading agency: {error.message}</p>
      </div>
    );
  }
  return { isLoading, settings, AgencyData, baseURL };
};
